import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';

import { LogService } from '../services/log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private _injector = inject(Injector);

  handleError(error: any): void {
    const logService = this._injector.get(LogService);
    logService.logError(error);
    console.error('🔥 Error Global Capturado:', error);
  }
}
